function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenCustomModel = function SvgOpenCustomModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 96,
    height: 96,
    viewBox: "0 0 11 11"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.194 10.685-.265-1.667q-.25-.092-.529-.251-.278-.159-.49-.33l-1.56.713L.12 6.98l1.428-1.044q-.026-.12-.033-.271-.007-.153-.007-.272t.007-.27.033-.272L.12 3.806l1.23-2.17 1.562.715q.211-.172.49-.331.277-.159.528-.238l.265-1.68h2.434l.265 1.667q.251.092.536.244.284.152.482.338l1.561-.715 1.23 2.17-1.428 1.019q.027.132.033.284t.007.284q0 .133-.007.278t-.033.278l1.429 1.032-1.23 2.17-1.562-.715q-.211.172-.482.337-.272.166-.536.245l-.265 1.667zm1.217-3.572q.714 0 1.217-.503.503-.502.503-1.217 0-.714-.503-1.217-.503-.502-1.217-.502t-1.217.502-.503 1.217q0 .715.503 1.217t1.217.503m0-.794q-.384 0-.655-.27-.271-.272-.271-.656 0-.383.271-.654.271-.272.655-.272t.655.272.271.654-.271.655-.655.271M4.83 9.891h1.164l.185-1.481q.437-.106.827-.331t.708-.542l1.402.608.53-.952L8.4 6.28q.053-.225.086-.443.033-.219.033-.444 0-.224-.027-.443-.026-.218-.092-.443l1.243-.913-.529-.952-1.402.608q-.304-.344-.688-.575-.384-.232-.847-.298L5.993.895H4.83l-.185 1.482q-.45.093-.84.318t-.695.555l-1.402-.608-.53.952 1.244.913q-.053.225-.086.443-.033.219-.033.443 0 .225.033.444.033.218.086.443l-1.243.913.529.952 1.402-.608q.318.317.708.542t.827.33z",
    style: {
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.208,
    height: 1.633,
    x: 4.803,
    y: 3.421,
    ry: 0.049,
    style: {
      fill: "#fff",
      strokeWidth: 0.209373
    }
  }));
};
export default SvgOpenCustomModel;